import styled from "styled-components";
import { COLORS } from "../../../constants/Styles";

const ButtonContainer = styled.div`
  width: 100%;

  > button {
    float: right;
  }
`;

const ModalContainer = styled.div`
  margin-top: 1rem;
  width: 100%;
`;

const LinkContainer = styled.div`
  text-align: center;
  margin-bottom: 1rem;

  > a {
    color: ${COLORS.linkBlue};
  }

  &:hover {
    color: ${COLORS.secondary};
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;

  > button {
    width: 150px;
  }
`;

const FileInput = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;

const LinksContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const FormType = styled.div`
  display: flex;
  margin-bottom: 2rem;
  color: ${COLORS.secondaryLight};
`;

export {
  ButtonContainer,
  ModalContainer,
  LinkContainer,
  ButtonsContainer,
  FileInput,
  LinksContainer,
  FormType,
};
